



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
    apiKey: "AIzaSyC83I5ELJtw5poDDeo0vi8oiVPMZSsvlHM",
  authDomain: "elite-medicalcare.firebaseapp.com",
  projectId: "elite-medicalcare",
  storageBucket: "elite-medicalcare.firebasestorage.app",
  messagingSenderId: "228336276220",
  appId: "1:228336276220:web:f8c108fe45c38b6c74bd79",
  measurementId: "G-EWX4H76PGJ"
 
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



